// Small, Firebase-SDK-independent helpers for browser session restoration.
// Keeping this logic isolated makes it explicit that a transient service error
// must never be translated into an Auth sign-out.
export function waitForInitialAuthState(authInstance, subscribe) {
  return new Promise((resolve) => {
    let unsubscribe = null;
    let settled = false;
    const settle = (user) => {
      if (settled) return;
      settled = true;
      resolve(user || null);
      unsubscribe?.();
    };
    unsubscribe = subscribe(
      authInstance,
      settle,
      () => settle(authInstance.currentUser || null),
    );
    // Some test adapters (and some SDK implementations) can synchronously
    // deliver the first state before returning their unsubscribe function.
    if (settled) unsubscribe?.();
  });
}

export async function restoreBrowserAuthSession({
  authInstance,
  setPersistence,
  persistence,
  subscribe,
  persistenceTimeoutMs = 2500,
}) {
  // Safari can leave a persistence migration pending even though the existing
  // local Firebase session is readable. Do not let that SDK edge case prevent
  // the initial auth observer from being attached forever.
  await Promise.race([
    Promise.resolve(setPersistence(authInstance, persistence)).catch(() => undefined),
    new Promise((resolve) => setTimeout(resolve, persistenceTimeoutMs)),
  ]);
  return waitForInitialAuthState(authInstance, subscribe);
}
